import moment from 'moment-timezone';

export const getTimezone = (): string => {
  let timezone = 'America/Los_Angeles';
  if (Intl && Intl.DateTimeFormat) {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  return timezone;
};

export const convertTimeWithTimezone = (
  date: moment.MomentInput,
  format = 'MM/DD/YYYY - HH:mm z',
  timezone: string = getTimezone()
): string => {
  if (date) {
    const formattedTime = moment.tz(date, timezone).format(format);
    return formattedTime;
  }
  return '';
};

export const processDateRangeQuery = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queries: Record<string, any>,
  dateRangeKey: string,
  startDateKey: string,
  endDateKey: string
): void => {
  if (queries[dateRangeKey]) {
    const dates = (queries[dateRangeKey] as string)
      .replace(/\s/gi, '')
      .split('-');
    if (dates.length === 2) {
      queries[startDateKey] = convertTimeWithTimezone(
        dates[0],
        'YYYY-MM-DD',
        undefined
      );
      queries[endDateKey] = convertTimeWithTimezone(
        dates[1],
        'YYYY-MM-DD',
        undefined
      );
    }
    delete queries[dateRangeKey];
  }
};
